<template>
  <main
    class="row pt-3 mx-0 mb-50px"
  >
    <b-col
      lg="10"
      offset-lg="1"
    >
      <h3 class="mb-4">
        {{ $t("Add containers") }}
      </h3>

      <form @submit.prevent>
        <b-row>
          <b-col>
            <dx-form-group :label="$t('company')">
              <dx-select-box
                v-model="container.company"
                :data-source="companies"
                value-expr="id"
                :display-expr="companyDisplayExpr"
                styling-mode="outlined"
              />
            </dx-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col>
            <dx-form-group
              :label="$t('containers')"
              :margin-bottom="false"
            >
              <dx-text-area
                v-model="container.containers"
                value-change-event="input"
                height="120"
                styling-mode="outlined"
                :max-length="1000"
              />
            </dx-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="10">
            <ul>
              <li
                v-for="item in getContainers()"
                :key="item.number"
              >
                {{ item.number }} <span
                  v-if="!item.valid"
                  style="color:red"
                >{{ $t("container number not valid") }}</span>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="10">
            <dx-button
              :text="$t('Add')"
              type="success"
              styling-mode="contained"
              class="custom-btn mr-2"
              :disabled="!this.container.company || !isAllContainersValid()"
              @click="onSubmit"
            />
          </b-col>
        </b-row>
      </form>
    </b-col>
  </main>
</template>

<script>
import { mapState } from 'vuex';

import {
  DxSelectBox,
  DxTextBox,
  DxNumberBox,
  DxCheckBox,
  DxDateBox,
  DxTextArea,
  DxFileUploader,
  DxButton,
} from 'devextreme-vue'; // eslint-disable-line
import { DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxRadioGroup } from 'devextreme-vue/radio-group';

import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxEditing,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxSelection,
  DxStateStoring,
  DxPaging,
  DxPager,
  DxLookup,
} from 'devextreme-vue/data-grid';

import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import DxFormGroup from '@/components/common/DxFormGroup';
import DxFieldsetHeader from '@/components/common/DxFieldsetHeader';

import createCustomStore from '@/utils/create-custom-store';
import containerNumberValidator from '@/utils/container-number-validator';


const contentDisposition = require('content-disposition');

export default {
  name: 'AddContainer',
  components: {
    DxSelectBox,
    DxTextBox,
    DxNumberBox,
    DxDateBox,
    DxTextArea,
    DxCheckBox,
    DxFormGroup,
    DxFieldsetHeader,
    DxDataGrid,
    DxExport,
    DxColumn,
    DxLookup,
    DxEditing,
    DxHeaderFilter,
    DxGroupPanel,
    DxSearchPanel,
    DxSelection,
    DxStateStoring,
    DxFileUploader,
    DxPaging,
    DxPager,
    DxButton,
    DxPopup,
    DxScrollView,
    DxRadioGroup,
    DxTextBoxButton,
  },
  props: {
    id: String,
  },
  data: vue => ({
    createCustomStore,
    container: {
      company: null,
      containers: '',
    },
    companies: null,
  }),
  computed: {
    ...mapState(['user']),
  },
  watch: {},
  async created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  mounted() {
    this.companies = {
      store: createCustomStore('profile/api/companies/'),
      paginate: true,
    };
    if (this.$route.query.company) {
      this.container.company = +this.$route.query.company;
    }
  },
  methods: {
    onSubmit() {
      this.addFreightOrder();
    },
    companyDisplayExpr(company) {
      return company ? `${company.name} ${company.inn || ''}` : '';
    },

    async addFreightOrder() {
      await this.$http.post('/container_tracking/api/container/multi/', {
        company_id: this.container.company,
        numbers: this.getContainers()
          .map(i => i.number),
      });
      this.$router.push('/tracking/monitoring');
    },

    normalize_space(value) {
      // Replace repeated spaces, newlines and tabs with a single space
      return value.replace(/^\s*|\s(?=\s)|\s*$/g, '');
    },
    getContainers() {
      let s = this.container.containers;
      s = s.replace(/\r/g, ' ');
      s = s.replace(/\n/g, ' ');
      s = s.replace(/,/g, ' ');
      const results = [];
      const uniq = [...new Set(this.normalize_space(s)
        .split(' '))];
      uniq.forEach(i => {
        results.push(
          {
            number: i,
            valid: containerNumberValidator(i),
          },
        );
      });
      return results;
    },
    isAllContainersValid() {
      let result = true;
      this.getContainers()
        .forEach((i) => {
          result = result && i.valid;
        });
      return result;
    },
  },
};
</script>
